import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../services/api";
import { show } from "../../../notifications/notifications";
import { NotificationsLevel } from "../../../lib/enums";
import { deliveryMethodsKeys } from "../queryKeys";

const useDeleteDeliveryMethod = (name: string) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: (id: number) => api.destroyAction(id),
    onSuccess: () => {
      show({
        level: NotificationsLevel.SUCCESS,
        message: `Delivery method '${name}' deleted.`
      });
      queryClient.invalidateQueries({ queryKey: deliveryMethodsKeys.list });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: `An error occurred while deleting the delivery method.`
      });
    }
  });

  return { deleteDeliveryMethod: mutate, isDeletingDeliveryMethod: isPending };
};

export default useDeleteDeliveryMethod;
